/*
 * Copyright (c) 2023. Legalbird eine Marke der R+S Internet Jewels GmbH
 */


import ProcessCostSupportList from "../../ProcessCostSupport/ProcessCostSupportList";

const ProcessCostSupportListPage = () => {
  return <ProcessCostSupportList />;
};

export default ProcessCostSupportListPage;
